<template>
  <NuxtLayout name="media">
    <section class="mediaAlbumLogin__Content">
      <div class="mediaAlbumLogin__FormWrapper">
        <div class="mediaAlbumLogin__InnerWrapper">
          <h1 v-text="page.title" />
          <p class="mediaAlbumLogin__IntroText">
            <span v-text="$t('mediaAlbumIntro')" />&nbsp;
            <nuxt-link to="mailto:marketing@aminess.com" target="_blank">marketing@aminess.com</nuxt-link>
          </p>

          <div class="customError__Wrapper">
            <div v-if="customError && Object.keys(customError).length" class="customError">
              <p v-text="$t(`formErrors.${ customError.code.code }`)" />
            </div>
          </div>
  
          <form @submit.prevent class="absoluteLabelsForm">
            <TextField v-model="form.username" :label="$t('forms.username')" :errors="formErrors?.details?.username?.code" />
            <TextField class="form__PasswordField form__PasswordFirstField" v-model="form.password" :label="$t('forms.password')" type="password" :errors="formErrors?.details?.password?.code">
              <template #append>
                <button type="button" @click="togglePasswordVisibility">
                  <Icon name="password" />
                  <Icon name="password-hide" />
                </button>
              </template>
            </TextField>

            <Button class="mediaAlbumLogin__FormSubmitButton" medium full-width @click="submitLogin" :disabled="dataFetchInProgress">{{ $t('login.login') }}</Button>
          </form>
        </div>
      </div>

      <aside>
        <FlarePicture
					:src="{
						1920: { src: page.image, width: 1000, height: 1370, size: 'both', crop: 'fill' },
						1440: { src: page.image, width: 730, height: 1000, size: 'both', crop: 'fill' },
						768: { src: page.image, width: 750, height: 580, size: 'both', crop: 'fill' },
					}"
					:alt="page.image?.alt"
          :lazy="false"
          fetchPriority="high"
        />
      </aside>
    </section>
  </NuxtLayout>
</template>

<script setup>
  const { login } = useAuth('local')
  const { link } = useSetup()
  const props = defineProps({
    page: {}
  });

  const dataFetchInProgress = ref(false);
  const formErrors = ref(null);
  const { customError, setCustomError } = useCustomFormErrors(formErrors.value);
  const form = ref({
    username: '',
    password: ''
  });

  async function submitLogin() {
    dataFetchInProgress.value = true;
    try {
      await login({ username: form.value.username, password: form.value.password });
      await navigateTo(link('MediaAlbum'));
    } catch(error) {
      console.log(error)
      if (error.data) formErrors.value = error.data;
      setCustomError(formErrors.value, null, 'details');
    }
    dataFetchInProgress.value = false;
  }
</script>

<style lang="scss">
  @import url('@/assets/styles/pages/_mediaAlbumLogin.scss');
</style>
